export const PRIVACY_MODES = [
  {
    id: 'private',
    label: 'Private',
    description: 'Only you can access this archive until you invite someone.',
    locked: true,
  },
  {
    id: 'invite_only',
    label: 'Invite-only',
    description: 'Family and collaborators join by invitation — nothing is public.',
    locked: true,
  },
  {
    id: 'published',
    label: 'Published memory view',
    description: 'A read-only memory page you can share (memorial, QR, or NFC later). No editing tools.',
    locked: false,
  },
];

export const PERMISSION_LEVELS = [
  { id: 'view', label: 'View', description: 'Browse the archive' },
  { id: 'comment', label: 'Comment', description: 'View and leave notes (when available)' },
  { id: 'contribute', label: 'Contribute', description: 'Add and edit stories, people, and documents' },
  { id: 'export', label: 'Export', description: 'Download PDF and backup exports' },
  { id: 'manage', label: 'Manage', description: 'Invites, privacy, and archive settings (owner)' },
];

export const ROLE_TO_PERMISSION = {
  viewer: 'view',
  editor: 'contribute',
  owner: 'manage',
};

export function permissionLabel(id) {
  return PERMISSION_LEVELS.find((p) => p.id === id)?.label || id;
}

export function privacyModeLabel(id) {
  return PRIVACY_MODES.find((m) => m.id === id)?.label || id;
}

export function formatActivityWhen(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}
